import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomFieldDefinitionWithTargets } from 'types/customField';
import request from 'utils/request';
import { SEQUENCES_CUSTOM_FIELDS_KEY } from './useSequenceCustomFieldDefinitions';

function createSequenceCustomField(newField: CustomFieldDefinitionWithTargets) {
  return request('/sequences-custom-fields', {
    method: 'POST',
    body: newField,
  });
}

export const useCreateSequenceCustomFieldDefinition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSequenceCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_CUSTOM_FIELDS_KEY],
      });
    },
  });
};
